function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { price } from 'researcher/helpers/price';
import { T, useTranslate } from 'shared/helper/translate';
import Popover from 'researcher/components/Popover';
var PreferredGroupWidget = function PreferredGroupWidget(_ref) {
  var addPreferredGroup = _ref.addPreferredGroup,
    companyShortName = _ref.companyShortName,
    currency = _ref.currency,
    preferredGroup = _ref.preferredGroup,
    removePreferredGroup = _ref.removePreferredGroup,
    userIdentity = _ref.userIdentity;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    saving = _useState2[0],
    setSaving = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    groupCode = _useState4[0],
    setGroupCode = _useState4[1];
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var handleAddPreferredGroup = function handleAddPreferredGroup(e) {
    e.preventDefault();
    setSaving(true);
    addPreferredGroup(userIdentity, groupCode.value).then(setSaving(false));
  };
  var handleRemovePreferredGroup = function handleRemovePreferredGroup() {
    setSaving(true);
    removePreferredGroup(userIdentity, preferredGroup.code).then(function () {
      return setSaving(false);
    });
  };
  if (!preferredGroup) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card widget-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-users"
    }), " ", /*#__PURE__*/React.createElement(T, {
      source: "Join a group"
    })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(T, {
      source: "Join group Tooltip",
      params: companyShortName
    })), /*#__PURE__*/React.createElement("form", {
      onSubmit: handleAddPreferredGroup
    }, /*#__PURE__*/React.createElement("input", {
      className: "form-control",
      type: "text",
      ref: setGroupCode,
      name: "groupCode",
      disabled: saving
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("button", {
      "aria-label": t('Submit'),
      className: "btn btn-primary",
      type: "submit",
      name: "Submit",
      disabled: saving
    }, /*#__PURE__*/React.createElement(T, {
      source: "Submit"
    })), saving ? /*#__PURE__*/React.createElement("span", null, "&nsbp;", /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-spinner-scale",
      spin: true
    })) : null)));
  }
  if (!preferredGroup.membershipDisplayed || !currency) {
    return null;
  }
  var discount = parseFloat(preferredGroup.discount);
  return /*#__PURE__*/React.createElement("div", {
    className: "card bg-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-users"
  }), " ", /*#__PURE__*/React.createElement(T, {
    source: "Group discount"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement(T, {
    source: "Discount"
  })), "\xA0", /*#__PURE__*/React.createElement(Popover, {
    content: "Non-progressive discount hint Tooltip"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-circle-question"
  }))), /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement("big", null, preferredGroup.percentageDiscount ? "".concat(discount.toFixed(2), "%") : price(currency, discount, true, true))), preferredGroup.shareable ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T, {
    source: "Share discount code",
    params: preferredGroup.code
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Leave Group'),
    type: "button",
    className: "btn btn-link ps-0",
    onClick: handleRemovePreferredGroup
  }, /*#__PURE__*/React.createElement(T, {
    source: "Leave Group"
  })))) : null));
};
export default PreferredGroupWidget;